const createAtributes = (data) => {
    const attributes = [];
    Object.keys(data).forEach((item) => {
        if (item.includes("Property")) {
            let index = item.substring(8);
            if (data["Value" + index]) {
                attributes.push({
                    trait_type: data[item],
                    value: data["Value" + index],
                });
            }
        }
    });
    return attributes;
};

export { createAtributes };
